/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../api/DataItemAPI',
	'./api/QueryDataItemAPI'
], (_, APIFactory, DataItemAPI, QueryDataItemAPI) => {
	class QueryDataItem extends QueryDataItemAPI {

		constructor(metadataColumn, dataItemId, dataItem) {
			super(metadataColumn, dataItem);

			if (!metadataColumn) {
				throw new Error('Missing parameter: MetadataColumnAPI');
			}

			this.metadataColumn = metadataColumn;
			this.dataItemId = dataItemId;

			// declare the defaults
			this.projected = true;
			this.commandList = [];


			// apply the spec to the data item instance
			if (dataItem) {
				_.extend(this, dataItem);
			}
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [DataItemAPI, QueryDataItemAPI]);
			}
			return this.api;
		}

		///////////////////////////////////
		// QueryDataItemAPI implementation
		getProjected() {
			return this.projected;
		}

		setProjected(projected) {
			this.projected = projected;
		}

		getCommandList() {
			return this.commandList;
		}

		addCommand(command) {
			this.commandList.push(command);
		}

		setType(type){
			this.type = type;
		}

		///////////////////////////////////
		// DataItemAPI implementation
		getId() {
			return this.dataItemId;
		}

		getLabel() {
			return this.metadataColumn.getLabel();
		}

		getColumnId() {
			return this.metadataColumn.getId();
		}

		getDataType() {
			return this.metadataColumn.getDataType();
		}

		isDateOrTimeType() {
			return this.metadataColumn.isDateTimeDataType();
		}

		getType() {
			return this.type || this.metadataColumn.getType();
		}

		getAggregation() {
			return typeof this.aggregation !== 'undefined' ? this.aggregation : this._getDefaultAggregation();
		}

		setAggregation(aggregation = null) {
			this.aggregation = aggregation;
		}

		getSort() {
			if (this.sort) {
				return this.sort;
			}
			const metadataColumnSortType = this.metadataColumn.getDefaultSortType();
			if (metadataColumnSortType) {
				return {
					type: metadataColumnSortType,
					priority: 1
				};
			}
		}

		getTopBottom() {
			return this.topBottom;
		}

		getMetadataColumn() {
			return this.metadataColumn;
		}

		getFormat(options) {
			return this.format || this.metadataColumn.getFormat(options);
		}

		getBinning() {
			return this.binning;
		}

		getDrillUpValue() {
			return this.drillUpValue;
		}

		getDrillDownValue() {
			return this.drillDownValue;
		}

		hasDefaultAggregation() {
			return typeof this.aggregation === 'undefined';
		}

		hasDefaultSort() {
			return !this.sort;
		}

		hasDefaultFormat() {
			return !this.format;
		}

		setSort(sortSpec) {
			this.sort = sortSpec;
		}

		setFormat(formatSpec) {
			this.format = formatSpec;
		}

		setTopBottom(topBottomInfo) {
			this.topBottom = topBottomInfo;
		}

		setBinning(binningSpec) {
			this.binning = binningSpec;
		}

		canDrillDown() {
			return false;
		}

		drillUp(value) {
			this.drillUpValue = value;
		}

		drillDown(value) {
			this.drillDownValue = value;
		}

		clearDrill() {
			delete this.drillUpValue;
			delete this.drillDownValue;
		}
		//////////////////////////////
		//QueryDataItem private function(s)
		_getDefaultAggregation() {
			return this.metadataColumn.getDefaultAggregation();
		}
	}

	return QueryDataItem;
});
